import { defineStore } from 'pinia'
import { Notify } from '@/types/store'
import { uuid } from '@/composables/uuid'
import { z } from 'zod'
import { computed, ref, toRaw } from 'vue'

export const useNotifyStore = defineStore('notify', () => {
  const notifications = ref<Array<Notify>>([])

  const getNotifications = computed(() => toRaw(notifications))

  function createNotify(notify: Notify) {
    const validate = Notify.safeParse(notify)
    if (!validate.success) {
      notifications.value.push({
        id: uuid('v4'),
        alertType: 'error',
        title: 'Error',
        message: 'Notify creation failed'
      })
      return
    }

    notifications.value.push(validate.data)
  }

  function removeNotify(id: string) {
    const validate = z.string().uuid().safeParse(id)
    if (!validate.success) {
      notifications.value.push({
        id: uuid('v4'),
        alertType: 'error',
        title: 'Error',
        message: 'Notify Id needs to be an instance of uuid'
      })
      return
    }
    notifications.value = notifications.value.filter(
      (notify) => notify.id !== validate.data
    )
  }

  return { notifications, createNotify, removeNotify, getNotifications }
})
